if (!customElements.get('togglerFacets')) {
  customElements.define(
    'toggler-facets',
    class togglerFacets extends HTMLElement {
      constructor() {
        super();

        this.facetsWrapper = document.querySelector('.facets-vertical');
        window.addEventListener('DOMContentLoaded', this.init.bind(this));
        window.addEventListener('resize', this.init.bind(this));
        this.addEventListener('click', this.toggleFacets.bind(this));
      }

      toggleFacets(event) {
        event.preventDefault();
        this.facetsWrapper.classList.toggle('facets--hide');
        const gridProduct = document.querySelector('#product-grid');
        gridProduct.classList.toggle('adapte-grid-product');
      }

      init(event) {
        if (window.matchMedia('(max-width: 1024px)').matches) {
          this.facetsWrapper.classList.add('facets--hide');
        } else {
          this.facetsWrapper.classList.remove('facets--hide');
        }
      }
    },
  );
}
